import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
    GetContracts, AddNewContract, GetContractByUserId, GetUserOwnContracts, UpdateContractWithCompletedBookings, UpdateContract
} from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetContracts(filters = {}) {
    return useQuery(['contracts', filters], () => GetContracts(filters), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch contracts", error);
            console.error("Error fetching contracts:", error);
        }
    });
}

export function useGetContractsByUserId(userId) {
    return useQuery(['contracts', userId], () => GetContractByUserId(userId), {
        enabled: !!userId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.contracts || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch contracts", error);
            console.error("Error fetching contracts:", error);
        }
    });
}
// export function useGetContractById(contractId) {
//     return useQuery(['contract', contractId], () => GetContractById(contractId), {
//         enabled: !!contractId,
//         staleTime: 5 * 60 * 1000, // 5 minutes
//         onError: (error) => {
//             Notify("Failed to fetch contract details", "error");
//             console.error("Error fetching contract details:", error);
//         }
//     });
// }

export function useAddContract() {
    const queryClient = useQueryClient();
    return useMutation(AddNewContract, {
        onSuccess: () => {
            Notify("Contract added successfully");
            queryClient.invalidateQueries('contracts');
            queryClient.invalidateQueries('offices');
            queryClient.invalidateQueries('seats');
        },
        onError: (error) => {
            NotifyError("Failed to add contract", error);
            console.error("Error adding contract:", error);
        }
    });
}

export function useUpdateContract() {
    const queryClient = useQueryClient();
    return useMutation(({ contractId, data }) => UpdateContract(contractId, data), {
        onSuccess: () => {
            Notify('Contract updated successfully');
            queryClient.invalidateQueries('contracts');
            queryClient.invalidateQueries('offices');
            queryClient.invalidateQueries('seats');
        },
        onError: (error) => {
            NotifyError(error?.response?.data?.message || 'Failed to update contract', error);
            console.error('Error updating contract:', error);
        }
    });
}

// export function useDeleteContract() {
//     const queryClient = useQueryClient();
//     return useMutation(DeleteContract, {
//         onSuccess: () => {
//             Notify("Contract deleted successfully", "success");
//             queryClient.invalidateQueries('contracts');
//         },
//         onError: (error) => {
//             Notify("Failed to delete contract", "error");
//             console.error("Error deleting contract:", error);
//         }
//     });
// }


export const useGetUserOwnContracts = () => {
    return useQuery(['contracts', 'user', 'own'],
        () => GetUserOwnContracts(), {
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.contracts || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch contracts", error);
            console.error("Error fetching contracts:", error);
        }
    });
};

export const useUpdateContractWithCompletedBookings = () => {
    const queryClient = useQueryClient();
    return useMutation(({ contractId, data }) => UpdateContractWithCompletedBookings(contractId, data), {
        onSuccess: () => {
            Notify("Contract updated successfully");
            queryClient.invalidateQueries('contracts');
        },
        onError: (error) => {
            NotifyError(error.response?.data?.message || "Failed to update contract", error);
            console.error("Error updating contract:", error);
        }
    });
};